@let features = configService.config().configuration?.features;

<div class="flex-container-column full-width">
    <curafida-card
        data-testid="user-preferences-main-card"
        [title]="'MAIN_CONFIGURATION'"
        class="full-width">
        <ion-card-content>
            @if (resource()) {
                <form>
                    @if (user().roles.includes(UserRoles.PATIENT)) {
                        @if (patientMode().length > 1) {
                            <curafida-select-field
                                [isMobile]="isMobile()"
                                [field]="preferencesForm.currentMode"
                                [itemList]="patientMode()"
                                [label]="'USER_PREFERENCES.VIEW'">
                            </curafida-select-field>
                        }
                    } @else {
                        <div class="flex-container-row full-width">
                            <ion-label
                                class="half-width item-label-profil bold ion-label-color-disabled ion-padding-top"
                                >{{ 'MODULE.PLURAL' | translate }}
                            </ion-label>
                            <div
                                [class.ion-item-box-disable]="!isEditEnabled()"
                                [class.ion-item-box-enable]="isEditEnabled()"
                                class="flex-container-column item-input-width ion-item-box text-standard-input-size">
                                <ion-item
                                    class="full-width"
                                    lines="none">
                                    <ion-checkbox
                                        [formField]="preferencesForm.course"
                                        labelPlacement="end"
                                        style="margin-right: 32px"
                                        >{{ 'MEETING.PLURAL' | translate }}
                                    </ion-checkbox>
                                </ion-item>
                            </div>
                        </div>
                    }
                    <div
                        [class.flex-container-row]="userPreferencesService.userPreferences()?.currentMode !== 'MINI'"
                        [class.flex-container-column]="
                            userPreferencesService.userPreferences()?.currentMode === 'MINI'
                        ">
                        <ion-label class="half-width item-label-profil bold ion-padding-top"
                            >{{ 'FONT_SIZE' | translate }}
                        </ion-label>
                        <div
                            [class.half-width]="userPreferencesService.userPreferences()?.currentMode !== 'MINI'"
                            [class.full-width]="userPreferencesService.userPreferences()?.currentMode === 'MINI'"
                            [class.ion-margin-horizontal]="
                                userPreferencesService.userPreferences()?.currentMode !== 'MINI'
                            "
                            class="flex-container-column">
                            <div class="full-width item-label-profil">
                                <ion-range
                                    [formField]="preferencesForm.fontSize"
                                    (ionChange)="changeTextSize($event)"
                                    class="range-profile"
                                    max="16"
                                    min="12"
                                    pin="true"
                                    snaps="true"
                                    step="2"
                                    ticks="true"
                                    data-testid="font-size-range-3d614037"></ion-range>
                            </div>
                            <div class="flex-container-row justify-content-space-between full-width item-label-profil">
                                <p>{{ 'USER_PREFERENCES.FONT_SIZE.SMALL' | translate }}</p>
                                <p>{{ 'USER_PREFERENCES.FONT_SIZE.NORMAL' | translate }}</p>
                                <p>{{ 'USER_PREFERENCES.FONT_SIZE.LARGE' | translate }}</p>
                            </div>
                        </div>
                    </div>
                </form>
                <curafida-save-cancel-button
                    (saveInformationEmit)="saveForm()"
                    (cancelEditEmit)="cancelForm()"
                    (toggleEditEmit)="toggleEdit()"
                    [element]="resource()"
                    [field]="preferencesForm"
                    [isEditEnabled]="isEditEnabled()"></curafida-save-cancel-button>
            }
        </ion-card-content>
    </curafida-card>
    @if (showEmailNotificationScope()) {
        <curafida-card
            data-testid="user-preferences-notification-card"
            [title]="'USER_PREFERENCES.NOTIFICATIONS'"
            class="full-width">
            <ion-card-content>
                @if (resource()) {
                    <form>
                        @if (features?.chat?.enabled) {
                            <div
                                slot="start"
                                class="full-width flex-container-row justify-content-space-between vertical-center">
                                <div class="email-notification-label">{{ 'CHAT.SINGULAR' | translate }} </div>
                                <hr style="width: 89%; border-top: 1px solid black" />
                            </div>
                            <curafida-select-field
                                [isMobile]="isMobile()"
                                [field]="preferencesForm.chatNotifications"
                                [itemList]="setItemList()"
                                [label]="'USER_PREFERENCES.EMAIL_NOTIFICATION_SCOPE.LABEL.CHAT'">
                            </curafida-select-field>
                        }
                        @if (features?.task?.enabled) {
                            <div
                                slot="start"
                                class="full-width flex-container-row justify-content-space-between ion-margin-top ion-padding-top vertical-center">
                                <div class="email-notification-label">{{ 'TASK.PLURAL' | translate }} </div>
                                <hr style="width: 90%; border-top: 1px solid var(--ion-color-medium)" />
                            </div>
                            <curafida-select-field
                                [isMobile]="isMobile()"
                                [field]="preferencesForm.taskStartNotifications"
                                [itemList]="setItemList()"
                                [label]="'USER_PREFERENCES.EMAIL_NOTIFICATION_SCOPE.LABEL.TASK_START'">
                            </curafida-select-field>
                            <curafida-select-field
                                [isMobile]="isMobile()"
                                [field]="preferencesForm.taskDueDateNotifications"
                                [itemList]="setItemList()"
                                [label]="'USER_PREFERENCES.EMAIL_NOTIFICATION_SCOPE.LABEL.TASK_DUE_DATE'">
                            </curafida-select-field>
                            <curafida-select-field
                                [isMobile]="isMobile()"
                                [field]="preferencesForm.taskFinishedDateNotifications"
                                [itemList]="setItemList()"
                                [label]="'USER_PREFERENCES.EMAIL_NOTIFICATION_SCOPE.LABEL.TASK_FINISHED_DATE'">
                            </curafida-select-field>
                        }
                        @if (features?.task?.enabled || features?.course?.enabled) {
                            <div
                                slot="start"
                                class="full-width flex-container-row justify-content-space-between ion-margin-top ion-padding-top vertical-center">
                                <div class="email-notification-label">{{ 'APPOINTMENTS' | translate }} </div>
                                <hr style="width: 90%; border-top: 1px solid var(--ion-color-medium)" />
                            </div>
                            <curafida-select-field
                                [isMobile]="isMobile()"
                                [field]="preferencesForm.termineStartNotifications"
                                [itemList]="setItemList()"
                                [label]="'USER_PREFERENCES.EMAIL_NOTIFICATION_SCOPE.LABEL.TERMIN_START'">
                            </curafida-select-field>
                            <curafida-select-field
                                [isMobile]="isMobile()"
                                [field]="preferencesForm.termineChangeNotifications"
                                [itemList]="setItemList()"
                                [label]="'USER_PREFERENCES.EMAIL_NOTIFICATION_SCOPE.LABEL.TERMIN_CHANGE'">
                            </curafida-select-field>
                        }
                        @if (features?.training?.enabled) {
                            <div
                                slot="start"
                                class="full-width flex-container-row justify-content-space-between ion-margin-top ion-padding-top vertical-center">
                                <div class="email-notification-label">{{ 'TRAINING.SINGULAR' | translate }} </div>
                                <hr style="width: 90%; border-top: 1px solid var(--ion-color-medium)" />
                            </div>
                            <curafida-select-field
                                [isMobile]="isMobile()"
                                [field]="preferencesForm.trainingStartNotifications"
                                [itemList]="setItemList()"
                                [label]="'USER_PREFERENCES.EMAIL_NOTIFICATION_SCOPE.LABEL.TRAINING_START'">
                            </curafida-select-field>
                            <curafida-select-field
                                [isMobile]="isMobile()"
                                [field]="preferencesForm.trainingEndNotifications"
                                [itemList]="setItemList()"
                                [label]="'USER_PREFERENCES.EMAIL_NOTIFICATION_SCOPE.LABEL.TRAINING_END'">
                            </curafida-select-field>
                        }
                        @if (isPatient() && features?.announcement?.enabled) {
                            <div
                                slot="start"
                                class="full-width flex-container-row justify-content-space-between ion-margin-top ion-padding-top vertical-center">
                                <div class="email-notification-label">{{ 'ANNOUNCEMENT.PLURAL' | translate }} </div>
                                <hr style="width: 90%; border-top: 1px solid var(--ion-color-medium)" />
                            </div>
                            <curafida-select-field
                                [isMobile]="isMobile()"
                                [field]="preferencesForm.announcementNotifications"
                                [itemList]="booleanScope"
                                [label]="'USER_PREFERENCES.EMAIL_NOTIFICATION_SCOPE.LABEL.ANNOUNCEMENT'">
                            </curafida-select-field>
                        }
                        @if (isCareUser()) {
                            <div
                                slot="start"
                                class="full-width flex-container-row justify-content-space-between ion-margin-top ion-padding-top vertical-center">
                                <div class="email-notification-label">{{ 'USER.PATIENT.PLURAL' | translate }} </div>
                                <hr style="width: 90%; border-top: 1px solid var(--ion-color-medium)" />
                            </div>
                            <curafida-select-field
                                [isMobile]="isMobile()"
                                [field]="preferencesForm.newPatientAssignedNotifications"
                                [itemList]="booleanScope"
                                [label]="'USER_PREFERENCES.EMAIL_NOTIFICATION_SCOPE.LABEL.NEW_ASSIGNED_PATIENT'">
                            </curafida-select-field>
                            <curafida-select-field
                                [isMobile]="isMobile()"
                                [field]="preferencesForm.newPatientNotifications"
                                [itemList]="booleanScope"
                                [label]="'USER_PREFERENCES.EMAIL_NOTIFICATION_SCOPE.LABEL.NEW_PATIENT'">
                            </curafida-select-field>
                        }
                    </form>
                    <curafida-save-cancel-button
                        (saveInformationEmit)="saveForm()"
                        (cancelEditEmit)="cancelForm()"
                        (toggleEditEmit)="toggleEdit()"
                        [element]="resource()"
                        [field]="preferencesForm"
                        [isEditEnabled]="isEditEnabled()"></curafida-save-cancel-button>
                }
            </ion-card-content>
        </curafida-card>
    }
</div>
